<template>
  <div class="g-update-layout docs-update">
    <!-- 标题 -->
    <div class="g-update-layout-title">
      <h3>
        {{ this.id ? $t('docs_form_edit_prop_title') : $t('docs_form_add_title') }}
      </h3>

      <div class="g-upadte-layout-btn">
        <a-button
          type="default"
          @click="
            () => {
              this.$router.go(-1);
            }
          "
        >
          {{ $t('com_btn_back') }}
        </a-button>

        <a-button type="primary" @click="onSubmit" :loading="loading" v-if="hasWritePermissioin">
          {{ $t('com_btn_save') }}
        </a-button>
      </div>
    </div>

    <!-- 内容 -->
    <div class="g-update-layout-content docs-update-content">
      <Loading :show="pageLoading" v-if="pageLoading" />
      <div class="form-model-update" v-else>
        <!-- 编辑/添加表单 -->
        <a-form-model
          :model="form"
          :rules="rules"
          ref="updateForm"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 18 }"
          style="width:760px; height: 100%; overflow-y: auto;"
          v-if="hasWritePermissioin"
        >
          <!-- 名称 -->
          <a-form-model-item :label="$t('docs_form_name')" prop="title">
            <a-input
              v-model="form.title"
              style="min-width:200px"
              :placeholder="$t('docs_form_name_placeholder')"
              allowClear
            />
          </a-form-model-item>

          <!-- 分类 -->
          <a-form-model-item :label="$t('docs_form_category')" prop="wcId">
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.wcId"
              :placeholder="$t('docs_form_category_placeholder')"
              show-search
              allowClear
              :filter-option="
                (input, option) => {
                  return (
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              "
              v-if="categoryList && categoryList.length > 0"
            >
              <a-select-option
                :value="category.id"
                v-for="category in categoryList"
                :key="category.id"
              >
                {{ category.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 文档类型，只有root/infypower帐号可编辑和填写 -->
          <a-form-model-item
            :label="$t('docs_form_type')"
            prop="type"
            :extra="$t('docs_form_type_help')"
            v-if="isSuperAdmin"
          >
            <a-input-number
              v-model="form.type"
              style="min-width:200px"
              :placeholder="$t('docs_form_type_placeholder')"
              allowClear
            />
          </a-form-model-item>

          <!-- 文档简介 -->
          <a-form-model-item :label="$t('docs_form_description')" prop="intro">
            <a-input
              type="textarea"
              v-model="form.intro"
              style="min-width:200px;"
              :placeholder="$t('docs_form_description_placeholder')"
              rows="5"
              allowClear
            />
          </a-form-model-item>

          <!-- 图标 -->
          <a-form-model-item :label="$t('docs_form_docs_icon')" prop="icon">
            <!-- 最多允许上传5个文件，可同时选择多个文件一起上传 -->
            <UploadOSS
              :value="form.icons"
              :manuallyUpload="true"
              :multiple="true"
              @change="
                fileList => {
                  form.icons = fileList || [];
                }
              "
              :maxCount="1"
              ref="uploadFile"
              uploadDirInOSS="document"
              uploadType="image"
            />
          </a-form-model-item>

          <!-- 读权限 -->
          <a-form-model-item :label="$t('docs_form_auth_read')" prop="readLevel">
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.readLevel"
              :placeholder="$t('docs_form_auth_placeholder')"
              allowClear
            >
              <a-select-option :value="item.value" v-for="item in readList" :key="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 写权限 -->
          <a-form-model-item :label="$t('docs_form_auth_write')" prop="writeLevel">
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.writeLevel"
              :placeholder="$t('docs_form_auth_placeholder')"
              allowClear
            >
              <a-select-option :value="item.value" v-for="item in writeList" :key="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 错误描述 -->
          <div class="form-error-text">
            <Icon type="error" v-if="formError" />
            <p>{{ formError }}</p>
          </div>
        </a-form-model>
        <NoAuth v-else />
      </div>
    </div>
  </div>
</template>
<script>
import * as DocsAPI from '@/api/docs';
import { hasReadWritePermission } from '@/libs/permissions';
import docsAuth from '@/views/docs/mixins/docsAuth';
import { mapState } from 'vuex';

export default {
  mixins: [docsAuth],
  data() {
    return {
      // 分类
      categoryList: null,
      // 读权限列表
      readList: [
        { label: '0', value: 0 },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
      ],
      // 写权限列表
      writeList: [
        { label: '0', value: 0 },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
      ],

      rules: {
        title: [
          {
            required: true,
            message: this.$t('docs_form_title_placeholder'),
            trigger: 'change',
          },
        ],
        wcId: [
          {
            required: true,
            message: this.$t('docs_form_category_placeholder'),
            trigger: 'change',
          },
        ],
        readLevel: [
          {
            required: true,
            message: this.$t('docs_form_auth_placeholder'),
            trigger: 'change',
          },
        ],
        writeLevel: [
          {
            required: true,
            message: this.$t('docs_form_auth_placeholder'),
            trigger: 'change',
          },
        ],
      },
      // 搜索
      form: {
        // "外键：文档分类主键，必填",
        wcId: undefined,
        //  "在线文档标题，必填",
        title: undefined,
        // 文档类型
        type: undefined,

        //  "在线文档简介，也可当着tip，可选",
        intro: undefined,
        //  "图片地址, 可多个地址,前端赋值如:icons: ['xxx', 'xxx', 'xxx']",
        icons: undefined,
        //  "读权限,读权限默认5。注意考虑此用户角色的Wiki读权限值",
        readLevel: 5,
        //  "写权限,写权限默认0。注意考虑此用户角色的Wiki写权限值"
        writeLevel: 0,
      },
      id: undefined,

      formError: '',
      formIsEdit: false,
      loading: false,

      detail: null,
    };
  },
  created() {
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.id = this.$route.params.id;
    }
    this.getData();
  },
  computed: {
    ...mapState(['pageLoading', 'isSuperAdmin']),
    // 是否有数据编辑（包括删除、禁用等）权限
    hasWritePermissioin() {
      // 添加的时候不需要判断写权限，有功能功能就OK
      if (!this.id) {
        return this.AUTH_DOCS_ADD;
      }
      return this.detail && hasReadWritePermission('write', 'wiki', this.detail?.writeLevel);
    },
  },
  methods: {
    // 获取表单数据
    getData() {
      const _list = [this.getAllDocuments()];
      // 如果是编辑，获取数据
      if (this.id) {
        _list.push(this.getDocumentInfo());
      }
      Promise.all(_list).finally(() => {
        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
      });
    },

    // 获取分类列表
    getAllDocuments() {
      return DocsAPI.getAllCategories()
        .then(res => {
          if (res.code === 0 && res.data) {
            this.categoryList = res.data || [];
          }
        })
        .catch(() => {
          this.categoryList = null;
        });
    },
    // 保存提交
    onSubmit() {
      this.$refs.updateForm.validate(valid => {
        if (valid) {
          this.loading = true;

          // 上传图片后再提交
          this.$refs.uploadFile.handleUpload(() => {
            const params = {
              ...this.form,
            };

            // if (!params.icons || params.icons.length === 0) {
            //   params.icons = undefined;
            // }

            let submitFn = null;

            if (this.id) {
              // 编辑
              params.id = Number(this.id);
              submitFn = DocsAPI.editDocument;
            } else {
              // 新增
              submitFn = DocsAPI.addDocument;
            }

            // 上传图片后再提交
            submitFn(params)
              .then(res => {
                if (res.code === 0) {
                  this.$success({
                    title: this.$t('com_msg_save_success'),
                    okText: this.$t('com_btn_back'),
                    maskClosable: true,
                    closable: true,
                    onOk: () => {
                      this.$router.go(-1);
                    },
                  });
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {
                this.$message.error(this.$t('com_msg_save_fail'));
              })
              .finally(() => {
                this.loading = false;
              });
          });
        }
      });
    },

    // 获取数据
    getDocumentInfo() {
      if (this.id) {
        DocsAPI.getDocumentDetail({ id: this.id }).then(res => {
          if (res && res.data) {
            this.detail = res.data;
            this.form = {
              wcId: res.data.wikiCategoryId,
              title: res.data.title,
              intro: res.data.intro,
              icons: res.data.icons,
              readLevel: res.data.readLevel,
              writeLevel: res.data.writeLevel,
              type: res.data.type,
            };
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.docs-update {
  // 内容
  .docs-update-content {
    height: calc(100% - 102px);
    border-radius: 12px;
    .form-model-update {
      height: auto;
    }
    ::v-deep .docs-update-regin-area {
      .docs-update-area {
        min-width: 260px;
      }

      .docs-update-region {
        min-width: 200px;
      }

      .ant-form-item-children {
        display: flex;
        align-items: flex-start;
        padding-top: 5px;
      }
    }
  }
}
</style>
